import NewDashboard from 'components/dashboard-2';

const DashboardPage = () => {
  return <NewDashboard />;
};

export default DashboardPage;
